<template>
  <div class="communityDetailItem communityProduct">
    <div class="head flex-js-ac" @click="goHome">
      <head-pendant :identity="detailItem.identity">
        <img
          width="37"
          class="headimg"
          height="37"
          :src="detailItem.authorhead"
          @error="
            (event) => {
              let img = event.srcElement
              img.src = errorHeadImg
              img.onerror = null
            }
          "
        />
      </head-pendant>
      <div class="nickname flex-1 f0">
        <div class="flex-ac">
          <p class="f14 over-ell-1">{{ detailItem.authorname }}</p>
          <img
            v-if="detailItem.authorlevel && detailItem.authorlevel != 0"
            :src="$getVipLevel(detailItem.authorlevel)"
          />
        </div>
        <span class="f11">{{ detailItem.time }}</span>
      </div>
      <button
        class="f11"
        v-if="detailItem.ismyself != 1 && !followBtnHide"
        @click.stop="followFn"
        :class="{
          'color-FC0324 follow-red': !detailItem.isfollow,
          'color-9': detailItem.isfollow
        }"
      >
        {{ detailItem.isfollow == 1 ? '取消关注' : '关注' }}
      </button>
    </div>
    <div class="content f0" v-if="titleTopShow" style="margin-top: 0.1rem" @click.stop="goDetail">
      <span class="f16" v-if="detailItem.title" style="font-weight: bold; margin-bottom: 0.02rem">
        {{ detailItem.title }}
      </span>
    </div>
    <div
      v-if="detailItem.isvideo == 1 || detailItem.coverimg"
      class="images flex-ac"
      @click.stop="goDetail"
    >
      <div class="cover imgbox imgbox1">
        <img v-lazy="detailItem.coverimg" />
        <img class="isvideo center" src="/static/images/community/video2.png" />
      </div>
    </div>
    <div
      v-else-if="detailItem.img_paths && detailItem.img_paths.length"
      class="images flex-ac"
      :class="{ 'flex-jc-ac': detailItem.img_paths.length != 2 }"
    >
      <div
        class="cover imgbox"
        :class="{ imgbox1: detailItem.img_paths.length == 1 }"
        v-for="(item, index) of detailItem.img_paths"
        v-if="index < 3"
      >
        <!-- 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start -->
        <img
          @click.stop="preview(index)"
          v-lazy="
            item +
            ($cos.isCosSwitch == 1
              ? $cos.pathSymbol(item) + $cos.imageLinkParamsStr
              : '?x-oss-process=image/format,jpg')
          "
          alt=""
        />
        <!-- 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End -->
      </div>
    </div>
    <div class="content f0" v-if="!titleTopShow" @click.stop="goDetail">
      <span
        class="f16 over-ell-1"
        v-if="detailItem.title"
        style="font-weight: bold; margin-bottom: 0.02rem"
      >
        {{ detailItem.title }}
      </span>
      <span class="f14" v-if="detailItem.content">
        {{
          detailItem.content.length > 40
            ? detailItem.content.substr(0, 40) + '...'
            : detailItem.content
        }}
      </span>
      <span class="f14 more" v-if="detailItem.content" v-show="detailItem.content.length > 40">
        查看更多
      </span>
    </div>
    <p v-if="detailItem.subjectid" class="f12 flex-ac color-FC0324 topic">
      <img width="14" height="14" src="/static/images/community/community-topic-selected.png" />
      {{ detailItem.subject }}
    </p>
    <div v-if="detailItem.gooditemid" class="product flex-ac" @click.stop="goProdetail">
      <div class="scroll" v-if="detailItem.gooditemid">
        <ul>
          <li class="flex-s" @click.stop="goProdetail">
            <img v-lazy="detailItem.goodimg" />
            <div class="name flex-1" style="max-width: initial">
              <p class="f12 over-ell-2">{{ detailItem.goodname }}</p>
              <p class="f12 price">
                ¥{{ detailItem.goodsaleprice }}
                <span class="f10">¥{{ detailItem.goodcostprice }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="detailItem.comment && detailItem.comment.length"
      class="comments"
      @click.stop="goDetail"
    >
      <p class="f14 over-ell-2" v-for="(item, index) of detailItem.comment" :key="index">
        <span>{{ item.name }}：</span>
        {{ item.content }}
      </p>
    </div>
    <div class="btn flex-jsa-ac" :class="{ btnLine: btnLineShow }">
      <button class="f14 flex-1 flex-jc-ac" @click.stop="likeFn">
        <img
          v-if="!detailItem.islikes && !detailItem.ispraise"
          width="16"
          height="16"
          src="/static/images/community/home-Select-icon-default1@2x.png"
          alt=""
        />
        <img v-else width="16" height="16" src="/static/images/community/like.png" alt="" />
        {{ detailItem.praisenum ? detailItem.praisenum : 0 }}
      </button>
      <button class="f14 flex-1 flex-jc-ac" @click.stop="collectionFn">
        <img
          v-if="!detailItem.iscollection"
          width="16"
          height="16"
          src="/static/images/community/collection-icon-default1@2x.png"
          alt=""
        />
        <img v-else width="16" height="16" src="/static/images/community/collection1.png" alt="" />
        {{ detailItem.collectionnum ? detailItem.collectionnum : 0 }}
      </button>
      <button class="f14 flex-1 flex-jc-ac" @click.stop="goDetail">
        <img
          width="16"
          height="16"
          src="/static/images/community/comments-icon-default1@2x.png"
          alt=""
        />
        {{ detailItem.commentcnt ? detailItem.commentcnt : 0 }}
      </button>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import headPendant from '../common/headPendant'
import Vue from 'vue'

Vue.use(ImagePreview)
export default {
  name: 'communityDetailItem',
  components: {
    headPendant
  },
  props: {
    markPointData: {
      // 埋点用
      type: Object,
      default: function () {
        return {}
      }
    },
    detailItem: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    followBtnHide: {
      type: Boolean,
      default: false
    },
    titleTopShow: {
      type: Boolean,
      default: false
    },
    btnLineShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    preview: function (index) {
      var list = this.detailItem.img_paths.map((item) => {
        // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start
        item =
          item +
          (this.$cos.isCosSwitch == 1
            ? this.$cos.pathSymbol(item) + this.$cos.imageLinkParamsStr
            : '?x-oss-process=image/format,jpg')
        // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End
        return item
      })
      ImagePreview({
        images: list,
        startPosition: index,
        closeOnPopstate: true
      })
    },
    goHome: function () {
      if (this.detailItem.isbeautitysaid == 1) {
        this.$store.commit('COMMUNITY_TAB', 3)
        this.$emit('headerClick', 3)
        if (this.$route.path == '/community') {
          this.$router.go()
        } else {
          this.$router.push({
            path: '/community'
          })
        }
      } else {
        var query = {}
        if (this.detailItem.ismyself != 1) {
          query.authorid = this.detailItem.authorid
        }
        this.$router.push({
          path: '/communitycenter',
          query: query
        })
      }
    },
    followFn: function () {
      var url = this.$ajax.community_follow_URL,
        data = {
          authorid: this.detailItem.authorid,
          isfollow: this.detailItem.isfollow ? 0 : 1
        }
      let detailItem = this.detailItem
      if (detailItem.isbeautitysaid == 1) {
        url = this.$ajax.follow_URL
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          detailItem.isfollow = detailItem.isfollow == 1 ? 0 : 1
          this.$emit('detailItemHandle', detailItem, this.index)
        }
      })
    },
    likeFn: function () {
      var url = this.$ajax.communityPosts_likes_URL,
        data = {
          type: 0,
          postsid: this.detailItem.itemid,
          ispraise: this.detailItem.islikes == 0 ? 1 : 0
        },
        detailItem = this.detailItem,
        that = this
      if (detailItem.isbeautitysaid == 1) {
        this.goDetail()
        return
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          f(detailItem)
        }
      })
      function f(item) {
        if (item.islikes == 0) {
          item.islikes = 1
          item.praisenum++
          that.$emit('detailItemHandle', detailItem, that.index)
        } else {
          item.islikes = 0
          item.praisenum--
          that.$emit('detailItemHandle', detailItem, that.index)
        }
      }
    },
    collectionFn: function () {
      var url = this.$ajax.communityPosts_collection_URL,
        data = {
          itemid: this.detailItem.itemid,
          iscollection: this.detailItem.iscollection == 0 ? 1 : 0
        },
        detailItem = this.detailItem,
        that = this
      if (detailItem.isbeautitysaid == 1) {
        this.goDetail()
        return
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          if (detailItem.iscollection == 0) {
            detailItem.iscollection = 1
            detailItem.collectionnum++
            that.$emit('detailItemHandle', detailItem, that.index)
          } else {
            detailItem.iscollection = 0
            detailItem.collectionnum--
            that.$emit('detailItemHandle', detailItem, that.index)
          }
        }
      })
    },
    goDetail() {
      var id = this.detailItem.itemid ? this.detailItem.itemid : this.detailItem.id
      if (this.detailItem.isbeautitysaid == 1) {
        this.$router.push({
          path: '/beautitysaiddetail',
          query: {
            beautitysaidid: id
          }
        })
      } else {
        this.$router.push({
          path: '/communitydetail',
          query: {
            id: id
          }
        })
      }
    },
    goProdetail: function () {
      let data = this.markPointData
      if (Object.keys(data).length > 0) {
        data.itemid = this.detailItem.gooditemid
        this.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: data
        })
      }

      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: this.detailItem.gooditemid
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/common/css/productList';
.communityDetailItem {
  width: 100%;
  /*margin: 0.1rem 0.11rem;*/
  padding: 0.1rem 0.11rem;
  background: #ffffff;
  border-radius: 0.04rem;
  .head {
    .headimg {
      border-radius: 50%;
      object-fit: cover;
    }
    .nickname {
      margin-left: 0.1rem;
      p {
        color: #222222;
        font-weight: 500;
      }
      img {
        /*width: 0.3rem;*/
        height: 0.16rem;
        margin-left: 0.02rem;
      }
      span {
        color: #afb0af;
      }
    }
    button {
      width: 0.64rem;
      height: 0.24rem;
      border: 0.01rem solid #ededed;
      border-radius: 0.12rem;
      background: transparent;
      outline: none;
      &.follow-red {
        border-color: #fc0324;
      }
    }
  }
  .images {
    margin: 0.12rem 0 0.08rem;
    position: relative;
    .imgbox {
      width: 1.04rem;
      height: 1.04rem;
      border-radius: 0.04rem;
      margin-left: 0.09rem;
      &:first-child {
        margin-left: 0;
      }
    }
    .imgbox1 {
      width: 3.31rem;
      height: 3.31rem;
    }
  }
  .content {
    color: #222222;
    & span.more {
      color: #338bf6;
    }
  }
  .topic {
    margin-top: 0.06rem;
    img {
      margin-right: 0.04rem;
    }
  }
  .product,
  .comments {
    margin-top: 0.1rem;
  }
  .comments {
    background: #f5f5f5;
    border-radius: 0.04rem;
    padding: 0.06rem;
    p {
      span {
        color: #999999;
      }
    }
  }
  .btn {
    margin-top: 0.12rem;
    &.btnLine {
      padding-top: 0.1rem;
      margin-top: 0.1rem;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 0.01rem;
        display: block;
        background-color: #f5f5f5;
      }
    }
    button {
      border-width: 0;
      background: transparent;
      outline: none;
      img {
        margin-right: 0.04rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/communityDetailItem.vue